// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  firebase: {
    apiKey: "***************************************",
    authDomain: "************************",
    projectId: "***********************************",
    storageBucket: "************************",
    messagingSenderId: "*********************",
    appId: "*******************************************",
    measurementId: "*********************"
  },

  keycloak: {
    authority: 'https://auth-dev.finapay.net/',
    redirectUri: 'https://api-admin-dev.finapay.net/',
    realm: 'finapay-admin',
    clientId: 'finapay-admin',
  },

  API_BASE: 'https://api-admin-dev.finapay.net',
  // API_BASE: 'http://192.168.88.12:8004/',
  API_TRANSACTION: 'https://api-transaction-dev.finapay.net/',

  API_FILE: 'https://statictest.lis-moi.com/',

  API_OPERATION: 'https://api-dev.finapay.net/operations'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
